export * as MapPinAssetsLarge from './assets-large';
export { Marker } from './Marker';
